import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from '../../../ui/Alert';

export default class ValidationErrors extends Component {
    static propTypes = {
        children: PropTypes.node,
        errors: PropTypes.object,
        status: PropTypes.string,
    }

    render() {
        const { status, children, errors } = this.props;
        if (!errors || errors.isEmpty()) {
            if (status === 'invalid') {
                // Todo add proper translation
                return (
                    <Alert type='warning'>
                        {'Oops. Something unexpected happened. Please reload the page and try again.'}
                    </Alert>
                );
            }
            else {
                return null;
            }

        }

        // TODO: Style me.
        return (
            <Alert type='warning'>
                {/* TODO */}
                {children}
                <ul>
                    {errors.map((fieldErrors, fieldKey) => (
                        fieldErrors.map((message, messageKey) => (
                            <li key={`${fieldKey}-${messageKey}`}>
                                {message}
                            </li>
                        )))
                    ).toArray()}
                </ul>
            </Alert>
        );
    }
}
